import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUsuarioActual } from '../../../redux/slices/autenticacion/autenticacion.slice'
import { AppConstantes } from '../../../utils/Constantes'
import dayjs from 'dayjs'

/**
 * Dropdown de notificaciones: lista las no leidas con fecha, enlace a pagina completa.
 * Si no hay notificaciones muestra estado vacio (SinNotificaciones).
 */
const HeaderNotificationsMenu: FC = () => {
  const usuarioActual = useSelector(selectUsuarioActual)
  const notificacionesNoLeidas = usuarioActual?.notificacionesNoLeidas

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'>
      <div className='d-flex flex-column bgi-no-repeat rounded-top bg-primary'>
        <h2 className='text-white fw-bold p-10 '>
          Notificaciones{' '}
          <span className='fs-5 opacity-75 ms-1'>
            {' '}
            {notificacionesNoLeidas &&
              notificacionesNoLeidas <= 0 &&
              `${usuarioActual?.notificacionesNoLeidas} sin leer`}
          </span>
        </h2>
      </div>
      {notificacionesNoLeidas && notificacionesNoLeidas > 0 ? (
        usuarioActual?.notificaciones?.map((n: any, index: number) => (
          <div key={n.idNotificacion} style={{ cursor: AppConstantes.NOT_ALLOWED }}>
            <div className='d-flex flex-stack' style={{ cursor: AppConstantes.NOT_ALLOWED }}>
              <div
                className='d-flex align-items-center bg-hover-light text-hover-primary w-100 p-4'
                style={{ cursor: 'default' }}>
                <span className='bullet bullet-dot bg-primary h-8px w-8px me-4 d-flex'></span>
                <div className='fs-5 text-gray-800 text-hover-primary fw-bold w-100 word-break text-break'>
                  {n.descripcion}
                  <div className='text-gray-500 fs-7'>
                    {dayjs(n.fechaCreacion).format('DD/MMM/YYYY')}
                  </div>
                </div>
              </div>
            </div>
            {index !== usuarioActual.notificaciones.length - 1 && (
              <div className='separator '></div>
            )}
          </div>
        ))
      ) : (
        <SinNotificaciones />
      )}
      <div
        className='py-2 text-center border-top'
        onClick={() => {
          document?.getElementById('kt_header')?.click()
        }}>
        <Link to='/notificaciones' className='btn btn-color-gray-600 btn-active-color-primary'>
          Ver todas <i className='fa-solid fa-arrow-right'></i>
        </Link>
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }

export const SinNotificaciones = () => {
  return (
    <>
      <div className='d-flex flex-stack' style={{ cursor: AppConstantes.NOT_ALLOWED }}>
        <div
          className='d-flex align-items-center bg-hover-light text-hover-primary flex-grow-1 py-3'
          style={{ cursor: 'default' }}>
          <div className='mb-0 me-2 fs-6 text-gray-800 text-hover-primary fw-bold w-100 h-20px d-flex justify-content-center align-items-center h-50px'>
            ¡No tienes notificaciones nuevas!
          </div>
        </div>
      </div>
    </>
  )
}
